import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function AddCategoryDiscountForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState();
  const [selectedOffer, setSelectedOffer] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [formData, setFormData] = useState({
    category_id: null,
    category_ids: [],
    start_date: "",
    end_date: "",
    dis_type: "",
    use_discount: "one_time",
    discount_amount: "",
    specific_customers: "no",
    is_offer: "no",
    multi_customer_id: [],
    category: [],
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (e) => {
    setFormData({
      ...formData,
      [e.name]: e.value,
    });
  };

  const handleCategorySelect = (e) => {
    if (id) {
      setFormData((prev) => ({
        ...prev,
        category_id: e.value,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        category_ids: e,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // setLoading(true);

    const disFormData = new FormData();

    // console.log(formData);
    // return;
    formData.category_ids?.forEach((item, idx) => {
      disFormData.append(`category_ids[${idx}]`, item.value);
    });
    disFormData.append("start_date", formData.start_date);
    disFormData.append("end_date", formData.end_date);
    disFormData.append("dis_type", formData.dis_type);
    disFormData.append("use_discount", formData.use_discount);
    disFormData.append("discount_amount", formData.discount_amount);
    disFormData.append("specific_customers", formData.specific_customers);
    disFormData.append("is_offer", formData.is_offer);
    if (selectedImage) {
      disFormData.append("offer_image", selectedImage);
    }
    disFormData.append("multi_customer_id", formData.multi_customer_id);
    disFormData.append("category", formData.category);

    if (!id) {
      axios
        .post(`${apiKey}/api/rms/admin/discounts`, disFormData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          Object.keys(err.response.data.data).forEach((item) => {
            err.response.data.data[item].forEach((i) => {
              toast.error(i || "Validation Error");
            });
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      disFormData.append("category_id", formData.category_id);
      axios
        .post(`${apiKey}/api/rms/admin/discounts/${id}?_method=PUT`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          Object.keys(err.response.data.data).forEach((item) => {
            err.response.data.data[item].forEach((i) => {
              toast.error(i || "Validation Error");
            });
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const discountTypes = [
    {
      label: languageHelper("Amount"),
      value: "amount",
      name: "dis_type",
    },
    {
      label: languageHelper("Percentage"),
      value: "percentage",
      name: "dis_type",
    },
  ];

  useEffect(() => {
    const fetchCategories = () => {
      return axios.get(`${apiKey}/api/rms/admin/categories`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchData = () => {
      Promise.all([fetchCategories()])
        .then(([dataRes]) => {
          const mappedCategories = dataRes.data.map((item) => ({
            label:
              defaultLang === "text_en"
                ? item.category_name
                : item.cat_name_arabic,
            value: item.id,
            // price: item.sale_price,
            name: "category_ids",
          }));
          setData(mappedCategories);
        })
        .catch((err) => {
          setError(err.response.data.message || "Some error occured");
        });
    };

    handleCSRF(fetchData);

    if (id) {
      setPageLoading(true);
      const fetchDiscount = () => {
        axios
          .get(`${apiKey}/api/rms/admin/discounts/${id}`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
            params: {
              includes: "category",
            },
          })
          .then((res) => {
            setFormData(res.data.data);
          })
          .catch((err) => {
            setError(err.response.data.message);
          })
          .finally(() => {
            setPageLoading(false);
          });
      };

      handleCSRF(fetchDiscount);
    }
  }, [id, user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper("Add Category Discount")}
            </h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-x-8 gap-y-2 w-full">
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Category Name")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    placeholder={languageHelper("Select")}
                    options={data}
                    defaultValue={formData.category.map((item) => ({
                      value: item?.id,
                      label: item?.category_name,
                    }))}
                    isMulti={!id}
                    onChange={handleCategorySelect}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Discount Type")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    placeholder={languageHelper("Select")}
                    options={discountTypes}
                    defaultValue={{
                      value: formData.dis_type,
                      label:
                        formData.dis_type === "percentage"
                          ? "Percentage"
                          : formData.dis_type === "amount"
                            ? "Amount"
                            : "",
                    }}
                    onChange={handleSelectChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Start Date")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="datetime-local"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder=""
                    value={formData.start_date}
                    name="start_date"
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  font-bold">
                  {languageHelper("End Date")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="datetime-local"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder=""
                    name="end_date"
                    value={formData.end_date}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative font-bold">
                  {languageHelper("Amount")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Amount")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="discount_amount"
                    value={formData.discount_amount}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <div className="form-check text-d-bg-text">
                  <div>
                    <h2>{languageHelper("Use Discount")}</h2>
                  </div>
                  <input
                    type="radio"
                    name="use_discount"
                    id="use_discount_one"
                    value="one_time"
                    defaultChecked={formData.use_discount === "one_time"} // Check based on value
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value, // Set the value to "one_time"
                      });
                    }}
                  />
                  <label
                    className="form-check-label pe-5 ps-3"
                    htmlFor="use_discount_one"
                  >
                    {languageHelper("One Time")}
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="use_discount"
                    id="use_discount_reg"
                    value="regular"
                    defaultChecked={formData.use_discount === "regular"} // Check based on value
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value, // Set the value to "regular"
                      });
                    }}
                  />
                  <label
                    className="form-check-label ps-3"
                    htmlFor="use_discount_reg"
                  >
                    {languageHelper("Regular")}
                  </label>
                </div>
              </label>
              <label htmlFor="">
                <div className="form-check text-d-bg-text">
                  <div>
                    <h2>{languageHelper("Is Offer ?")}</h2>
                  </div>
                  <input
                    type="radio"
                    name="is_offer"
                    id="is_offer_yes"
                    value="yes"
                    defaultChecked={formData.is_offer === "yes"} // Check based on value
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value, // Set the value to "one_time"
                      });
                    }}
                  />
                  <label
                    className="form-check-label pe-5 ps-3"
                    htmlFor="is_offer_yes"
                  >
                    {languageHelper("Yes")}
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="is_offer"
                    id="is_offer_no"
                    value="no"
                    defaultChecked={formData.is_offer === "no"} // Check based on value
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value, // Set the value to "regular"
                      });
                    }}
                  />
                  <label
                    className="form-check-label ps-3"
                    htmlFor="is_offer_no"
                  >
                    {languageHelper("No")}
                  </label>
                </div>
              </label>
              {formData.is_offer === "yes" && (
                <div className="flex flex-row items-center">
                  <input
                    type="file"
                    id="banner-input"
                    onChange={(e) => {
                      setSelectedOffer(e.target.files[0].name);
                      setSelectedImage(e.target.files[0]);
                    }}
                    hidden
                  />
                  <label
                    htmlFor="banner-input"
                    className="block text-sm text-white mr-4 py-2 px-4 rounded-md border-0 font-semibold bg-d-cat-btn cursor-pointer"
                  >
                    {languageHelper("Choose File")}
                  </label>
                  <label className="text-sm text-slate-500">
                    {selectedOffer}
                  </label>
                </div>
              )}
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="/assets/gif/button_loader.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddCategoryDiscountForm;
